// src/context/AuthProvider.js

import React, { createContext, useState, useEffect } from 'react';
import api from '../api/api';
import { jwtDecode } from 'jwt-decode';
import LoadingScreen from '../components/ui/LoadingScreen';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [contactEmail, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [quota, setQuota] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const storedEmail = localStorage.getItem('contactEmail');
        const storedPhone = localStorage.getItem('phone');

        if (token) {
            try {
                const decoded = jwtDecode(token);
                if (decoded.exp * 1000 > Date.now()) {
                    const userData = JSON.parse(decoded.sub); 
                    setUser(userData);
                    setQuota(userData.quota);
                    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                    if (storedEmail) setEmail(storedEmail);
                    if (storedPhone) setPhone(storedPhone);

                } else {
                    logout();
                }
            } catch (e) {
                console.error("Erreur en décodant le token au démarrage:", e);
            }
        }
        setLoading(false);
    }, []);

    const login = (token, userEmail, userPhone) => {
        try {
            const decoded = jwtDecode(token);
            
            // Stockage localStorage
            localStorage.setItem('token', token);
            localStorage.setItem('contactEmail', userEmail);
            localStorage.setItem('phone', userPhone);

            const userData = JSON.parse(decoded.sub);
            
            // Mise à jour du State
            setUser(userData);
            setQuota(userData.quota);
            setEmail(userEmail);
            setPhone(userPhone);
            
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            console.log("AuthProvider: Utilisateur connecté avec succès !", userData); 
            console.log("AuthProvider: Infos contact enregistrées !", { userEmail, userPhone });
        } catch (e) {
            console.error("AuthProvider: Le token reçu est invalide ou le 'sub' n'est pas du JSON", e);
            logout();
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('contactEmail');
        localStorage.removeItem('phone');
        
        setUser(null);
        setEmail(null);
        setPhone(null);
        setQuota(null);

        delete api.defaults.headers.common['Authorization'];
    };

    const refreshToken = (token) => {
        try {
            const decoded = jwtDecode(token);
            const userData = JSON.parse(decoded.sub);

            localStorage.setItem('token', token);
            setUser(userData);
            setQuota(userData.quota);
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            console.log("AuthProvider: Token rafraîchi avec succès !");

        } catch (e) {
            console.error("AuthProvider: Le nouveau token de rafraîchissement est invalide", e);
            logout();
        }
    };

    if (loading) {
        return <LoadingScreen message="Initialisation de l'application..." />;
    }

    return (
        <AuthContext.Provider value={{ 
            user, 
            contactEmail, 
            phone,
            quota,
            login, 
            logout, 
            refreshToken, 
            isAuthenticated: !!user 
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;